export default __webpack_public_path__ + "static/media/architecture-img-28.14741296.jpg";